import React, { useState } from 'react';
import { Outlet } from 'react-router-dom';
import { Layout } from 'antd';
import Sidebar from './Sidebar';
import Header from './Header';
import styles from './MainLayout.module.css';

const { Content } = Layout;

const MainLayout: React.FC = () => {
  const [collapsed, setCollapsed] = useState(false);

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  return (
    <Layout className={styles.mainLayout}>
      <Sidebar collapsed={collapsed} onCollapse={setCollapsed} />
      <Layout className={styles.siteLayout}>
        <Header collapsed={collapsed} onToggle={toggleSidebar} />
        <Content className={styles.mainContent}>
          <div className={styles.contentWrapper}>
            <Outlet />
          </div>
        </Content>
      </Layout>
    </Layout>
  );
};

export default MainLayout;